import { render, staticRenderFns } from "./postedService.vue?vue&type=template&id=26b90e48"
import script from "./postedService.vue?vue&type=script&lang=js"
export * from "./postedService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports